import { render, staticRenderFns } from "./RiskAssessmentProcedure.vue?vue&type=template&id=ef7b87f6&"
import script from "./RiskAssessmentProcedure.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports